<template>
  <div>
    <div class="text-red" v-if="message">{{message}}</div>
  </div>
</template>

<script>
  export default {
    name: 'ValidationErrors',
    props: ['errors'],
    computed: {
      message() {
        const errors = this.errors || [];
        return errors.join(', ');
      },
    },
  };
</script>


// WEBPACK FOOTER //
// ValidationErrors.vue?7ce67d48